import React from 'react';
import { StarIcon } from 'lucide-react';
export function RelatedTours() {
  const tours = [{
    id: 1,
    title: 'Santorini Catamaran Cruise with Lunch',
    image: 'https://images.unsplash.com/photo-1504512485720-7d83a16ee930?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80',
    price: 129,
    duration: '5 hours',
    rating: 4.9,
    reviewCount: 156,
    tag: 'Best Seller'
  }, {
    id: 2,
    title: 'Akrotiri Archaeological Site & Red Beach Tour',
    image: 'https://images.unsplash.com/photo-1602343168117-bb8ffe3e2e9f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80',
    price: 89,
    duration: '4 hours',
    rating: 4.7,
    reviewCount: 98,
    tag: 'Cultural'
  }, {
    id: 3,
    title: 'Santorini Cooking Class & Wine Tasting',
    image: 'https://images.unsplash.com/photo-1505075106905-fb052892c116?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80',
    price: 110,
    duration: '4 hours',
    rating: 4.8,
    reviewCount: 72,
    tag: 'Food & Drink'
  }, {
    id: 4,
    title: 'Santorini Photography Tour',
    image: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80',
    price: 95,
    duration: '3 hours',
    rating: 4.9,
    reviewCount: 64,
    tag: 'Small Group'
  }];
  const getTagColor = (tag: string) => {
    switch (tag) {
      case 'Best Seller':
        return 'bg-red-100 text-red-800';
      case 'Cultural':
        return 'bg-purple-100 text-purple-800';
      case 'Food & Drink':
        return 'bg-green-100 text-green-800';
      case 'Small Group':
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <section className="py-8" data-id="element-1361">
      <div className="container mx-auto px-4" data-id="element-1362">
        <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1363">
          You Might Also Like
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1364">
          {tours.map(tour => <div key={tour.id} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden group" data-id="element-1365">
              <div className="relative aspect-[3/2] overflow-hidden" data-id="element-1366">
                <img src={tour.image} alt={tour.title} className="w-full h-full object-cover transition-transform group-hover:scale-105" data-id="element-1367" />
                <div className={`absolute top-3 right-3 px-2 py-1 rounded-md text-xs font-medium ${getTagColor(tour.tag)}`} data-id="element-1368">
                  {tour.tag}
                </div>
              </div>
              <div className="p-4" data-id="element-1369">
                <div className="flex items-center mb-1" data-id="element-1370">
                  <div className="flex" data-id="element-1371">
                    <StarIcon size={14} className="text-yellow-400 fill-yellow-400" data-id="element-1372" />
                  </div>
                  <span className="ml-1 text-sm text-gray-700" data-id="element-1373">
                    {tour.rating}
                  </span>
                  <span className="ml-1 text-sm text-gray-500" data-id="element-1374">
                    ({tour.reviewCount})
                  </span>
                  <span className="mx-2 text-gray-300" data-id="element-1375">•</span>
                  <span className="text-sm text-gray-500" data-id="element-1376">{tour.duration}</span>
                </div>
                <h3 className="font-medium text-gray-900 group-hover:text-blue-600 transition-colors mb-2 line-clamp-2" data-id="element-1377">
                  {tour.title}
                </h3>
                <div className="flex items-baseline" data-id="element-1378">
                  <span className="text-lg font-bold text-gray-900" data-id="element-1379">
                    ${tour.price}
                  </span>
                  <span className="ml-1 text-sm text-gray-500" data-id="element-1380">per person</span>
                </div>
                <button className="mt-3 w-full py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-md transition-colors" data-id="element-1381">
                  View Details
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}